
import React from 'react';

const IRCDENTAL = () => {


    return (
        <>
            <div className="about-us-container">
                {/* Detailed Activities Section */}
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
                    </div>

                    {/* IRC Dental Clinic */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC DENTAL CLINIC (IDC)</h3>
                        </div>
                        <div className="activity-content">
                            <p>IRC Dental Clinic is a Reason to Smile Again! We are dedicated to providing top-notch dental care to everyone which includes a wide range of services like cleanings, fillings, root canals, and denture fittings. We prioritize preventive care and patient education, empowering individuals to take control of their oral health. With a team of skilled dentists, IRC Dental Clinic goes the extra mile by offering dental treatments at a very discounted rate and provides completely free medicines to everyone to ensure a healthier and brighter smile for every patient.</p>

                            <div className="clinic-card">
                                <h4>Clinic - 1 - Baijipura</h4>
                                <p><strong>Name:</strong> IRC Dental Clinic</p>
                                <p><strong>Address:</strong> IRC Community Centre, First Floor, Gali No. 34, Apex Hospital Road, Behind Sikandar Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431003.</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/IRC+Dental+Clinic/@19.8829708,75.3477762,153m/data=!3m1!1e3!4m6!3m5!1s0x3bdba3d309ff7ffb:0xa5c9e450a2c2ee3a!8m2!3d19.8829695!4d75.3484199!16s%2Fg%2F11v0s_c_cv?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=2b075fb7-c15f-4fc3-bb1d-0b10a6334861" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> 08-Jun-2023</p>
                                <p><strong>No. of Patients Treated:</strong> 13,238 (till 31-Jan-2025)</p>
                                <p><strong>Contact No:</strong> 9607-9607-67</p>
                            </div>

                            <div className="clinic-card">
                                <h4>Clinic - 2 - Kiradpura</h4>
                                <p><strong>Name:</strong> IRC Dental Clinic</p>
                                <p><strong>Address:</strong> Shop No 3, SK Tower, Plot No 1, Zone No 3, Jaswantpura, Kiradpura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/IRC+PHARMACY/@19.8877667,75.3506199,38m/data=!3m1!1e3!4m7!3m6!1s0x3bdba2a31ba7449d:0x1e738000eb1412fe!8m2!3d19.8877666!4d75.3508772!15sCgNpcmOSAQhwaGFybWFjeeABAA!16s%2Fg%2F11yrwt4xp8?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=8d1d4180-37a7-4858-9ea4-bac1bfcf1c13" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> 18-Sep-2024</p>
                                <p><strong>No. of Patients Treated:</strong> 2,179 (till 31-Jan-2025)</p>
                                <p><strong>Contact No:</strong> 8507-8507-32</p>
                            </div>

                            <div className="clinic-card">
                                <h4>Clinic - 3 - Buddi Lane</h4>
                                <p><strong>Name:</strong> IRC Dental Clinic</p>
                                <p><strong>Address:</strong> H.No 1-13-37, Near Nehru Bhawan, Fatima Maternity Hospital Road, Buddi Lane, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/IRC+Charitable+Clinic+Buddi+Lane/@19.8908514,75.3255802,611m/data=!3m1!1e3!4m7!3m6!1s0x3bdb99d12e1b4c21:0xa9ab83cdb84fb010!8m2!3d19.8908105!4d75.3275663!15sCgNpcmOSAQhob3NwaXRhbOABAA!16s%2Fg%2F11jz9m30zf?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=870b2347-d16d-4b82-ac21-27daff422575" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> NA</p>
                                <p><strong>No. of Patients Treated:</strong> NA</p>
                                <p><strong>Contact No:</strong> 7537-9999-22</p>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </>
    );
};

export default IRCDENTAL;